import { Transition } from '@headlessui/react';
import React from 'react'
import _ from 'lodash';
import {  format } from '../../services/common.service';
import { YesNoRendererComponent } from '../../components/yes-no-renderer.component';


export const ExpandTableComponent = ({ subRowDataId,row,isExpand,columnData,subFilteredFields,subRowData,subColumnDefs,handleExpandTableEdit,handleExpandTableDelete }: any) => (
          <>
          
  {
        subRowDataId === row?.Id && isExpand && (
         <tr >
             <td colSpan={10}  className={isExpand ? 'border-b border-2' : 'border-none'} >
             <Transition
         show={isExpand}
         enter="transition-transform duration-50 ease-out"
         leave="transition-transform duration-50 ease-in"
       >
             <table className="w-full text-xs bg-red-50">
             <thead className="w-full border-y border-black border-opacity-20 ">
                     <tr className="w-full text-left h-12">
                       {columnData[0]?.headerName && (
                         <th className="p-4 border-r-2">{columnData[0]?.headerName}</th>
                       )}
                       {subFilteredFields.map((subcolumn: any, index: number) => (
                         <th className="w-auto px-6 py-3 border-r-2 last:border-r-0 whitespace-nowrap " key={index}>{subcolumn.headerName}</th>
                       ))}
                     </tr>
                   </thead>
                   <tbody>
                     {subRowData?.map((subRow: any, subIndex: any) => (
                       <tr
                         key={subIndex}
                         className="bg-white border-2  overflow-y-auto"
                       >
                         
                         {subColumnDefs[0]?.headerName && (
                           <td className="p-4">{subIndex + 1}</td>
                         )}
                     
                         {subFilteredFields.map((subColumn: any, subColumnIndex: number) => {
                           const subDataValue: any = _.property(subColumn.field)(subRow);
       
                           return (
                             <>
                             <td
                               align={subColumn.align}
                               key={subColumnIndex}
                               className="px-10  w-auto"
                             >
                       {
                        
                          subColumn.isDateValueFormat !== true &&
                          subColumn.isAddressFormat !== true &&
                         
                                subColumn.cellRenderer !== 'yesNoRenderer' &&
                                !subColumn.valueFormatter &&
                                subColumn.cellRenderer !== 'viewRenderer' &&
                                
                           subDataValue}
              
                                    {subColumn.isDateValueFormat === true && 
                                    <p className=' font-semibold '>
                                    {format(subDataValue)}
                                  </p>
                                   }
                                   {subColumn.isAddressFormat === true && 
                                    <p className=' font-semibold '>
                                    {`${subDataValue?.address?.building} , ${subDataValue?.address?.locality} , ${subDataValue?.address?.city} , ${subDataValue?.address?.country} , ${subDataValue?.address?.state} - ${subDataValue?.address?.area_code}`}
                                  </p>
                                   }
       {subColumn.cellRenderer === 'yesNoRenderer' && (
                                     <YesNoRendererComponent cellRenderer={subColumn.cellRenderer} value={subDataValue} />
                                   )}
      
                     
                       </td>
                       </>
                           
                           );
                         })}
                       </tr>
                     ))}
                   </tbody>
                 </table>
                 </Transition>
             </td>
           </tr>
         )
       }
</>
)
export default ExpandTableComponent;
